export default "__VITE_ASSET__B_z1pPO6__"